import { Loader } from 'ui/components/primitives/Loader';
import { LAYOUT_CONST } from './Layout.d';
import { Layout } from './Layout.styles';
import type { LayoutProps } from './Layout.d';

const LayoutBase = ({
  alternateColor = false,
  children,
  fullPage = false,
  horizontalAlign = 'center',
  loading,
  verticalAlign = 'center',
  ...props
}: LayoutProps) => (
  <Layout.Component
    data-alternate={alternateColor}
    data-full-page={fullPage}
    data-horizontal-align={horizontalAlign}
    data-loading={loading}
    data-testid={LAYOUT_CONST.TEST_ID}
    data-vertical-align={verticalAlign}
    {...props}
  >
    {loading ? <Loader /> : children}
  </Layout.Component>
);

export default LayoutBase;
